import { useSearchParams } from 'react-router-dom';

import { useWorkstreamId } from '@/pages/shared/home/hooks/useWorkstreamId';
import { buildPath, BuildPathOptions } from '@/utils/buildPath';

export const useBuildPathWithDefaultQueryParams = () => {
  const [searchParams] = useSearchParams();
  const workstreamId = useWorkstreamId();

  const buildPathWithDefaultQueryParams = (
    path: string,
    { pathParams, queryParams }: BuildPathOptions | undefined = {},
  ) => {
    const plotGroupId = searchParams.get('plotGroupId');

    const queryParamsInternal =
      workstreamId || plotGroupId
        ? { ...(workstreamId ? { workstreamId } : {}), ...(plotGroupId ? { plotGroupId } : {}) }
        : undefined;

    return buildPath(path, {
      pathParams,
      queryParams: { ...queryParamsInternal, ...queryParams },
    });
  };

  return { buildPathWithDefaultQueryParams };
};
